
import React from 'react';
import { Square, ZoomIn } from "lucide-react";

interface CropperControlsProps {
  zoom: number;
}

const CropperControls = ({ zoom }: CropperControlsProps) => {
  return (
    <>
      <div className="flex items-center gap-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 bg-pink-50 px-3 py-2 rounded-full">
          <Square className="w-4 h-4 text-pink-500" />
          Perfect 1:1 square crop
        </div>
        <div className="flex items-center gap-2 bg-blue-50 px-3 py-2 rounded-full">
          <ZoomIn className="w-4 h-4 text-blue-500" />
          Zoom: {Math.round(zoom * 100)}%
        </div>
      </div>
      
      <div className="text-center text-xs text-gray-500 bg-gray-50 px-3 py-2 rounded-lg">
        💡 Use two fingers to pinch and zoom • Drag the crop area to reposition
      </div>
    </>
  );
};

export default CropperControls;
